import { FC } from "preact/compat";
import { useApp } from "~/core/store";
import { TimeDistance } from "~/components";
import { TrackerPiPProps } from "./interfaces";
import PauseIcon from "@material-design-icons/svg/outlined/pause.svg";
import PlayIcon from "@material-design-icons/svg/outlined/play_arrow.svg";
import Loader from "~/assets/loader.svg";
import cn from "classnames";

const EACH_SECOND = 1000;

const TrackerPiP: FC<TrackerPiPProps> = ({ onPlay, onTileClick }) => {
    const {
        tracker: { loading, activeTask, activeTile, activeExternal, tiles },
    } = useApp();
    const visibleTiles = tiles.value.filter((tile) => !tile.inactive);
    const currentActivity =
        activeTask.value || activeTile.value || activeExternal.value;
    const taskNameText = currentActivity?.name ?? "No active task";

    return (
        <div className="min-h-full w-full bg-gradient-to-r from-[#57215F] to-[#1A3F5C] p-4 text-white">
            <div className="flex min-h-[40px] items-center rounded-t-lg bg-[#335370] fill-current px-2 py-1 text-white">
                {loading.value ? (
                    <div className="p-0.5">
                        <Loader
                            width="20"
                            height="20"
                            className="text-sky-500"
                        />
                    </div>
                ) : (
                    <button
                        type="button"
                        title={currentActivity ? "Pause" : "Start"}
                        onClick={onPlay}
                        className="flex rounded-full p-0.5 outline-none transition duration-100 focus:ring-2 focus:ring-white active:scale-95"
                    >
                        {currentActivity ? (
                            <PauseIcon width="20" height="20" />
                        ) : (
                            <PlayIcon width="20" height="20" />
                        )}
                    </button>
                )}
                <div className="ml-2">
                    {currentActivity?.startDate && (
                        <TimeDistance
                            date={currentActivity.startDate}
                            className="cursor-default truncate"
                            period={EACH_SECOND}
                            withSeconds
                        />
                    )}
                </div>
                <div className="ml-2 max-w-[180px] truncate">
                    {taskNameText}
                </div>
            </div>
            <div className="flex flex-col rounded-b-lg bg-[#344757]">
                {visibleTiles.map((tile) => (
                    <button
                        type="button"
                        key={tile.id}
                        aria-label={`Start/Stop "${tile.name}"`}
                        onClick={() => onTileClick(tile)}
                        className={cn(
                            "flex min-h-[40px] w-full items-center fill-current px-2 py-1 hover:text-sky-400",
                            activeTile.value?.id === tile.id
                                ? "cursor-default text-sky-500"
                                : "",
                        )}
                    >
                        {activeTile.value?.id === tile.id ? (
                            <PauseIcon width="20" height="20" />
                        ) : (
                            <PlayIcon width="20" height="20" />
                        )}
                        <span className="ml-2">{tile.name}</span>
                    </button>
                ))}
            </div>
        </div>
    );
};

export default TrackerPiP;
